/*************************************************/
/* COOKIES                                       */
/*************************************************/

export function cookies() {
    const cookiePlaceholderSelector = '.cookie-placeholder';
    const placeholderSelectors = Array.from(document.querySelectorAll(cookiePlaceholderSelector));

    //Implement this for the specific cookie solution. Check out one of our other websites for an example
    const RenewConsent = categories => {
        CookieConsent.renew()
    }

    const SetPlaceholderDisplayState = (placeholder, displayState) => {
        placeholder.style.display = displayState;
    }

    //Implement this for the specific cookie solution. Check out one of our other websites for an example. In this case, replace the 'false' with Cookie Consent status
    const SetPlaceholderState = () => {

        const marketingPlaceholders = document.querySelectorAll('[data-category="marketing"]');
        if (marketingPlaceholders != null) {
            marketingPlaceholders.forEach(placeholder => {
                var displayState = CookieInformation.getConsentGivenFor('cookie_cat_marketing') ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder, displayState);
            });
        }

        var statisticPlaceholders = document.querySelectorAll('[data-category="statistic"]');
        if (statisticPlaceholders != null) {
            statisticPlaceholders.forEach(placeholder => {
                var displayState = CookieInformation.getConsentGivenFor('cookie_cat_statistic') ? 'none' : 'flex';

                SetPlaceholderDisplayState(placeholder, displayState);
            });
        }

        var functionalPlaceholders = document.querySelectorAll('[data-category="functional"]');
        if (functionalPlaceholders != null) {
            functionalPlaceholders.forEach(placeholder => {
                var displayState = CookieInformation.getConsentGivenFor('cookie_cat_functional') ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder, displayState);
            });
        }

    }

    const init = () => {

        window.addEventListener('CookieInformationConsentGiven', function (event) {
            SetPlaceholderState();
        }, false);
        
        SetPlaceholderState();

        for (const placeholderSelector of placeholderSelectors) {
            placeholderSelector.addEventListener('click', event => {
                let placeholder = event.target;
                if (!placeholder.classList.contains(cookiePlaceholderSelector)) {
                    placeholder = event.target.closest(cookiePlaceholderSelector);
                }
                event.stopPropagation()
                RenewConsent();
            });
        }
    };

    init();
}




// WEBPACK FOOTER //
// ./src/scripts/partials/cookies.js